<template>
  <div class="loader">
    <div class="loader__animation"></div>
  </div>
</template>

<script>
export default {}
</script>
